import styled from "styled-components"
import { ProjectContainerSmall } from "../../../templates/ProjectStyles"

export const TitleParagraphContainer = styled(ProjectContainerSmall)``;

